// docs: https://github.com/altostra/type-validations#readme
import { anyOf, enumOf, objectOf } from "@altostra/type-validations";
import { string, number, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGetAppsAppGroupIdUserImportsImportIdResult = objectOf({
  id: string,
  start_time: number,
  name: string,
  total_rows: number,
  import_count: number,
  malformed_count: number,
  no_id_count: number,
  is_done: boolean,
  segment_id: anyOf(string, nullOrUndefined),
  cancelled: boolean,
  download_link: anyOf(string, nullOrUndefined),
  error_report_download_link: anyOf(string, nullOrUndefined),
  has_error_report: boolean,
  is_uploaded_by_current_developer: boolean,
  validation_report_download_link: anyOf(string, nullOrUndefined),
  validation_started_at: anyOf(number, nullOrUndefined),
  validation_status: anyOf(
    enumOf("in_progress", "completed", "timed_out", "skipped", "cancelled"),
    nullOrUndefined
  ),
  validation_summary: objectOf({
    blocking_error_count: anyOf(number, nullOrUndefined),
    non_blocking_error_count: anyOf(number, nullOrUndefined),
    rows_checked: anyOf(number, nullOrUndefined),
  }),
  should_make_filterable: boolean,
  import_type: string,
  has_hit_user_limit: boolean,
  failed: boolean,
  developer: anyOf(string, nullOrUndefined),
});
